import { render, staticRenderFns } from "./PriceChangeStamp.vue?vue&type=template&id=22b254cc&scoped=true&lang=pug"
import script from "./PriceChangeStamp.vue?vue&type=script&lang=js"
export * from "./PriceChangeStamp.vue?vue&type=script&lang=js"
import style0 from "./PriceChangeStamp.vue?vue&type=style&index=0&id=22b254cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b254cc",
  null
  
)

export default component.exports